import { SET_DATA, DATA_LOADING } from "./types.js";
import * as Service from "./../apiService/service.js";

export const fetchDataAction = (payload,params) => async (dispatch) => {
  // dispatch({
  //   type: DATA_LOADING,
  //   payload: true,
  // });

  if (params.has("type"))
  {
    payload.blog_type=params.get("type");
  }

  if (params.has("id"))
  {
    payload.id=params.get("id");
  }
  
  var data = await Service.getData(payload);
  
  dispatch({
    type: SET_DATA,
    payload: data,
  });
  
  // dispatch({
  //   type: DATA_LOADING,
  //   payload: false,
  // });
};
